import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

const PeopleDesc = () => {
  const cickbutton = () => {
    if (window.location.pathname == "/peoplewall") {
      window.scrollTo(0, 2000);
    } else if (window.location.pathname == "/uploadimage/monuments") {
      window.scrollTo(0, 2000);
    } else if (window.location.pathname == "/uploadimage/effects") {
      window.scrollTo(0, 2000);
    } else if (window.location.pathname == "/") {
      window.scrollTo(0, 450);
    } else if (
      window.location.pathname == "/" &&
      localStorage.getItem("device") == "pwa" &&
      localStorage.getItem("device") == "iosapp" &&
      localStorage.getItem("device") == "androidapp"
    ) {
      window.scrollTo(0, 50);
    }
  };

  return (
    <>
      <section className="wall_padding">
        <div className="container">
          <div className="wall_content_container">
            <div className="row">
              <div className="col-sm-12 text-center">
                <div className="people_head">
                  <h2>
                    People’s <span>wall</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PeopleDesc;
